import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useAboutRaaiStore = defineStore('aboutRaai', {
    state() {
        return {
            aboutRaaiSections: [],
            aboutRaaiPage: {}
        }
    },
    actions: {
        async getAboutRaaiSections(withPages) {
            const data = {
                with_pages: withPages
            }

            this.aboutRaaiSections = await helper.api(
                'GET',
                '/about_raai_section',
                data
            )
        },

        async getAboutRaaiPage(pageId) {
            this.aboutRaaiPage = await helper.api(
                'GET',
                `/about_raai_section/pages/${pageId}`,
                {}
            )
        }
    }
})